import {Component} from 'react';

export default class enterTableList extends Component {

  componentDidMount() {
    this.customize = localStorage.getItem('customize') || '';
    this.freshTableList();
  }

  // 第一次刷新拉取table列表数据
  freshTableList = () => {
    const {getTableList} = this.props;

    getTableList();
  };
}
